import BaseGrow from '@material-ui/core/Grow'

const Grow = BaseGrow

export default Grow
